/*
 * Spinder PDP-galerij verrijking
 * ------------------------------
 * Voegt aan de Spinder-PDP-galerij ([data-spinder-gallery]) toe:
 *   - lightbox-venster (klik op hoofdfoto) met thumbnails links + loep-zoom
 *   - hover-pijltjes over de hoofdfoto (desktop), met toetsenbordbediening
 *   - swipen op mobiel + een eenmalige "swipe-hint"
 *
 * Werkt samen met spinder-product.js: navigeren gebeurt via de bestaande
 * thumbnails, zodat het variant-/kleurfilter automatisch gerespecteerd blijft.
 */
(function () {
  'use strict';

  var HI_RES = 2048;

  function atWidth(src, w) {
    if (!src) return src;
    try { var u = new URL(src, window.location.origin); u.searchParams.set('width', w); return u.toString(); }
    catch (e) { return src; }
  }

  // Zichtbare hoofdbeelden (= huidige kleurblok) als {src, thumb, alt, mediaId}.
  function collectImages(gallery) {
    var out = [];
    gallery.querySelectorAll('[data-spinder-stage-item]').forEach(function (item) {
      if (item.style.display === 'none') return;
      var img = item.querySelector('.spinder-pdp__stage-img');
      if (!img) return;
      var base = img.currentSrc || img.src;
      out.push({
        src: atWidth(base, HI_RES),
        thumb: atWidth(base, 200),
        alt: img.getAttribute('alt') || '',
        mediaId: item.getAttribute('data-media-id') || ''
      });
    });
    return out;
  }

  function visibleThumbs(gallery) {
    var out = [];
    gallery.querySelectorAll('[data-spinder-thumb]').forEach(function (btn) {
      var cell = btn.closest('.spinder-pdp__thumb-item') || btn;
      if (cell.style.display !== 'none') out.push(btn);
    });
    return out;
  }

  function navPage(gallery, dir) {
    var thumbs = visibleThumbs(gallery);
    if (thumbs.length <= 1) return;
    var active = gallery.querySelector('.spinder-pdp__stage-item.is-active');
    var activeId = active ? active.getAttribute('data-media-id') : null;
    var idx = -1;
    thumbs.forEach(function (b, i) { if (b.getAttribute('data-spinder-thumb') === activeId) idx = i; });
    if (idx < 0) idx = 0;
    var next = (idx + dir + thumbs.length) % thumbs.length;
    thumbs[next].click();
  }

  /* ---------------- Lightbox ---------------- */
  function Lightbox() { this.images = []; this.index = 0; this.zoomed = false; this._build(); }

  Lightbox.prototype._build = function () {
    var el = document.createElement('div');
    el.className = 'spd-lb';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', "Productfoto's");
    el.hidden = true;
    el.innerHTML =
      '<button type="button" class="spd-lb__close" aria-label="Sluiten"><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg></button>' +
      '<div class="spd-lb__body">' +
        '<ul class="spd-lb__thumbs" role="list"></ul>' +
        '<div class="spd-lb__stage">' +
          '<button type="button" class="spd-lb__nav spd-lb__nav--prev" aria-label="Vorige foto"><svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<div class="spd-lb__img-wrap" data-zoom="0"><img class="spd-lb__img" alt="" draggable="false"></div>' +
          '<button type="button" class="spd-lb__nav spd-lb__nav--next" aria-label="Volgende foto"><svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<div class="spd-lb__counter"><span class="spd-lb__cur">1</span> / <span class="spd-lb__tot">1</span></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    this.root = el;
    this.thumbsEl = el.querySelector('.spd-lb__thumbs');
    this.imgWrap = el.querySelector('.spd-lb__img-wrap');
    this.imgEl = el.querySelector('.spd-lb__img');
    this.curEl = el.querySelector('.spd-lb__cur');
    this.totEl = el.querySelector('.spd-lb__tot');

    var self = this;
    el.querySelector('.spd-lb__close').addEventListener('click', function () { self.close(); });
    el.querySelector('.spd-lb__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); self.go(-1); });
    el.querySelector('.spd-lb__nav--next').addEventListener('click', function (e) { e.stopPropagation(); self.go(1); });
    el.addEventListener('click', function (e) {
      if (e.target === el || e.target.classList.contains('spd-lb__body') || e.target.classList.contains('spd-lb__stage')) self.close();
    });
    this.imgWrap.addEventListener('click', function (e) { e.stopPropagation(); self.toggleZoom(e); });
    this.imgWrap.addEventListener('mousemove', function (e) { self.pan(e); });
    this.imgWrap.addEventListener('mouseleave', function () { if (self.zoomed) self.setOrigin(50, 50); });
    document.addEventListener('keydown', function (e) {
      if (self.root.hidden) return;
      if (e.key === 'Escape') self.close();
      else if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); self.go(1); }
    });
    var sx = 0, sy = 0, tracking = false;
    this.imgWrap.addEventListener('touchstart', function (e) { if (self.zoomed) return; tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    this.imgWrap.addEventListener('touchend', function (e) {
      if (!tracking) return; tracking = false;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.go(dx < 0 ? 1 : -1);
    }, { passive: true });
  };

  Lightbox.prototype.open = function (images, index) {
    this.images = images;
    this.index = Math.max(0, Math.min(index || 0, images.length - 1));
    this._renderThumbs();
    this.totEl.textContent = images.length;
    this.root.hidden = false;
    document.documentElement.classList.add('spd-lb-open');
    this._show();
    this.root.querySelector('.spd-lb__close').focus();
  };
  Lightbox.prototype.close = function () { this._unzoom(); this.root.hidden = true; document.documentElement.classList.remove('spd-lb-open'); };
  Lightbox.prototype._renderThumbs = function () {
    var self = this; this.thumbsEl.innerHTML = '';
    this.images.forEach(function (im, i) {
      var li = document.createElement('li');
      li.className = 'spd-lb__thumb';
      li.innerHTML = '<button type="button" aria-label="Foto ' + (i + 1) + '"><img src="' + im.thumb + '" alt="' + (im.alt || '') + '" loading="lazy"></button>';
      li.querySelector('button').addEventListener('click', function () { self.index = i; self._show(); });
      self.thumbsEl.appendChild(li);
    });
  };
  Lightbox.prototype._show = function () {
    this._unzoom();
    var im = this.images[this.index]; if (!im) return;
    this.imgEl.src = im.src; this.imgEl.alt = im.alt || '';
    this.curEl.textContent = this.index + 1;
    var thumbs = this.thumbsEl.querySelectorAll('.spd-lb__thumb');
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === this.index); }, this);
    if (thumbs[this.index] && thumbs[this.index].scrollIntoView) thumbs[this.index].scrollIntoView({ block: 'nearest' });
    var only = this.images.length <= 1;
    this.root.querySelector('.spd-lb__nav--prev').hidden = only;
    this.root.querySelector('.spd-lb__nav--next').hidden = only;
  };
  Lightbox.prototype.go = function (dir) { if (this.images.length <= 1) return; this.index = (this.index + dir + this.images.length) % this.images.length; this._show(); };
  Lightbox.prototype.toggleZoom = function (e) {
    if (this.zoomed) { this._unzoom(); }
    else { this.zoomed = true; this.imgWrap.setAttribute('data-zoom', '1'); this.pan(e); }
  };
  Lightbox.prototype._unzoom = function () { this.zoomed = false; this.imgWrap.setAttribute('data-zoom', '0'); this.setOrigin(50, 50); };
  Lightbox.prototype.pan = function (e) {
    if (!this.zoomed) return;
    var r = this.imgEl.getBoundingClientRect();
    var x = ((e.clientX - r.left) / r.width) * 100, y = ((e.clientY - r.top) / r.height) * 100;
    this.setOrigin(Math.max(0, Math.min(100, x)), Math.max(0, Math.min(100, y)));
  };
  // Zoom via transform-origin op de foto zelf (de loep volgt de cursor).
  Lightbox.prototype.setOrigin = function (x, y) { this.imgEl.style.transformOrigin = x + '% ' + y + '%'; };

  var lightbox = null;
  function getLightbox() { if (!lightbox) lightbox = new Lightbox(); return lightbox; }

  /* ---------------- Hover-pijltjes + swipe op de pagina ---------------- */
  function setupStage(gallery) {
    var stage = gallery.querySelector('.spinder-pdp__stage');
    if (!stage || stage.querySelector('.spd-gallery-nav')) return;

    function makeBtn(dir, label, path) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'spd-gallery-nav spd-gallery-nav--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="' + path + '" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); navPage(gallery, dir); });
      return b;
    }
    stage.appendChild(makeBtn(-1, 'Vorige foto', 'M15 5l-7 7 7 7'));
    stage.appendChild(makeBtn(1, 'Volgende foto', 'M9 5l7 7-7 7'));

    function updateArrows() {
      var hide = visibleThumbs(gallery).length <= 1;
      stage.querySelectorAll('.spd-gallery-nav').forEach(function (b) { b.hidden = hide; });
    }
    updateArrows();
    new MutationObserver(updateArrows).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

    // Klik op de hoofdfoto opent de lightbox.
    stage.addEventListener('click', function (e) {
      if (e.target.closest('.spd-gallery-nav')) return;
      var img = e.target.closest('.spinder-pdp__stage-img');
      if (!img) return;
      var imgs = collectImages(gallery);
      if (!imgs.length) return;
      var active = gallery.querySelector('.spinder-pdp__stage-item.is-active');
      var activeId = active ? active.getAttribute('data-media-id') : null;
      var idx = 0;
      imgs.forEach(function (im, i) { if (im.mediaId === activeId) idx = i; });
      getLightbox().open(imgs, idx);
    });
    gallery.querySelectorAll('.spinder-pdp__stage-img').forEach(function (img) { img.style.cursor = 'zoom-in'; });

    // Toetsenbord
    gallery.setAttribute('tabindex', gallery.getAttribute('tabindex') || '0');
    gallery.addEventListener('keydown', function (e) {
      if (document.documentElement.classList.contains('spd-lb-open')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); navPage(gallery, -1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); navPage(gallery, 1); }
    });

    // Swipe op mobiel
    var sx = 0, sy = 0, tracking = false;
    stage.addEventListener('touchstart', function (e) { tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!tracking) return; tracking = false;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) navPage(gallery, dx < 0 ? 1 : -1);
    }, { passive: true });

    // Eenmalige swipe-hint op mobiel: actieve foto wipt subtiel naar rechts.
    setupSwipeHint(gallery, stage);
  }

  function setupSwipeHint(gallery, stage) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (visibleThumbs(gallery).length <= 1) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.disconnect();
        var active = gallery.querySelector('.spinder-pdp__stage-item.is-active') || gallery.querySelector('[data-spinder-stage-item]');
        if (!active) return;
        active.classList.add('spd-hint');
        setTimeout(function () { active.classList.remove('spd-hint'); }, 1300);
      });
    }, { threshold: 0.6 });
    io.observe(stage);
  }

  function init() {
    document.querySelectorAll('[data-spinder-gallery]').forEach(setupStage);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
